document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const trigger = target.closest("button.scroll-to-summary");
    if (!trigger) return;

    event.preventDefault();

    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;
    const targetSection = document.querySelector(".section-confirmation-main");

    if (targetSection) {
        const sectionTop =
            targetSection.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
            top: sectionTop - headerHeight,
            behavior: "smooth",
        });
    }
});
